export default __webpack_public_path__ + "static/media/dropdown-arrow.bc14a1f1.svg";